import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { social } from "../../../enums";
import SingleSelect from "../../core/dropdown/single-select";
/*
// pre-configured SingleSelect for social networks

<SocialNetworkSelect
  onChange={ onChange }
/>
*/

var networks = _mapInstanceProperty(_).call(_, social, function (properties) {
  return {
    text: properties.display,
    value: properties.value,
    icon: properties.icon,
    key: properties.display
  };
});

var SocialNetworkSelect = createComponent({
  displayName: 'Social Network Select',
  propTypes: {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  },
  defaultProps: {
    value: '',
    id: ''
  },
  render: function render(props) {
    var socialProps = {
      options: networks,
      label: 'Social network',
      value: props.value,
      onChange: props.onChange,
      placeholder: social.ALL_NETWORKS.display,
      id: props.id,
      style: props.style
    };
    return /*#__PURE__*/React.createElement(SingleSelect, socialProps);
  }
});
export default SocialNetworkSelect;
//# sourceMappingURL=index.js.map